























import { Component, Vue, Prop } from 'vue-property-decorator';
import CustomerShow from '@/components/Customer/CustomerShow.vue';
import { GQL_customerListSearch_customers } from '@/queries/__generated__/customerListSearch';

@Component({
  components: {
    CustomerShow,
  },
})
export default class CustomerShowButton extends Vue {
  @Prop() public customer!: GQL_customerListSearch_customers;
  public showDialog = false;
}
